import {property} from '@wonderlandengine/api';
import {DefaultGameRules} from './default-game-rules.js';
import {Localization} from '../../utils/Localization.js';
import {StatNames} from '../../enums/StatNames.js';
import {Statistics} from '../statistics.js';
import {Analytics, AnalyticsEvent} from '../../classes/Analytics.js';
import {specialMode} from './game-rules.js';
import {LeaderboardManager} from '../leaderboard-manager.js';
import {GameModeType} from '../../enums/GameModeType.js';
import {timeSinceEpoch} from '../../utils/Utils.js';

export class EasyGameRules extends DefaultGameRules {
    static TypeName = 'easy-game-rules';
    static InheritProperties = true;

    @property.float(0)
    arrowLevel2 = 0;
    @property.float(0)
    arrowLevel3 = 0;
    @property.float(0)
    arrowLevel4 = 0;
    @property.float(0)
    arrowLevel5 = 0;

    @property.vector3(0, 0, 0)
    origTach = [0, 0, 0];
    @property.vector3(0, 0, 0)
    newTach = [0, 0, 0];
    @property.float(0)
    oldDuration = 0;
    @property.float(0)
    newDuration = 0;

    private _interruptRiseUp = false;
    //private _tachTween: any = null; // TODO: Add proper type

    start() {
        super.start();
        this._interruptRiseUp = false;
        //  this._tachTween = null;
    }

    override startNewGame(): void {
        super.startNewGame();
        // TL TODO: Implement the HUD changes.
        this.puzzleController.score.showEasyModeHud(true);
        this.puzzleController.score.setTachometerArrow(this.arrowLevel5);
        // tachTween = this.puzzleController.score.easyModeArrow.GetComponentInChildren<TweenRotation>();
        // origTach = tachTween.to;

        this._puzzle.score.showShapeCount(0);
    }

    override showFinalResults() {
        const combo = this.puzzleController.score.combo;

        this.puzzleController.score.showFinalResults(
            Localization.instance.get('BestChainFormat'),
            combo,
            Localization.instance.get('Easy'),
            StatNames.RecentHighScoreEasy
        );
    }

    override getHighScore() {
        const highScore = Statistics.instance.getLong(StatNames.HighScoreEasy);
        return highScore;
    }

    override getWeeklyHighScore() {
        return Statistics.instance.getLong(StatNames.RecentHighScoreEasy);
    }

    override saveHighScore(score: number) {
        Statistics.instance.recordHighest(StatNames.HighScoreEasy, score);
        // TK TODO: port code when leaderboard is implemented
        // HACK
        // This code shouldn't have to know about the leaderboard or terms!
        // if (Statistics.instance.getLong(StatNames.RecentHighScoreEasyTimestamp) < LeaderboardManager.CurrentTermStart() ||
        // 	Statistics.instance.getLong(StatNames.RecentHighScoreEasy) < score)
        // {
        // 	Statistics.instance.record(StatNames.RecentHighScoreEasy, score);
        // 	Statistics.instance.record(StatNames.RecentHighScoreEasyTimestamp, Utils.TimeSinceEpoch());
        // }
        if (Statistics.instance.recordHighest(StatNames.RecentHighScoreEasy, score)) {
            Statistics.instance.record(
                StatNames.RecentHighScoreEasyTimestamp,
                timeSinceEpoch()
            );
        }
        //ExternalInterface.Instance.SaveScoreToPlatformLeaderboard(score, GameFlowController.GameModeType.Easy);

        LeaderboardManager.instance.saveScoreToPlatformLeaderboard(
            score,
            GameModeType.Easy
        );
    }

    override saveCumulativeScore(score: number) {
        Statistics.instance.recordAdditive(StatNames.CumulativeScoreEasy, score);
        Statistics.instance.recordAdditive(StatNames.CumulativeScoreAny, score);

        let roundedScore: number;

        if (score > 10000000) {
            roundedScore = score - (score % 1000000);
        } else if (score > 1000000) {
            roundedScore = score - (score % 1000000);
        } else if (score > 100000) {
            roundedScore = score - (score % 100000);
        } else if (score > 10000) {
            roundedScore = score - (score % 10000);
        } else {
            roundedScore = score - (score % 1000);
        }

        //Logger.Log("score logged " + score + " = " + roundedScore);
        Analytics.LogEventWithValue(AnalyticsEvent.ScoreNormal, roundedScore);
    }

    override incrementGamesPlayed() {
        Statistics.instance.recordAdditive(StatNames.EasyGamesPlayed, 1);
        Statistics.instance.recordAdditive(StatNames.TotalGamesPlayed, 1);

        // if (this.getSpecialMode(specialMode.FreezeDrop) == true)
        // {
        // 	Statistics.instance.recordAdditive(StatNames.FreezeDropGamesPlayed, 1);
        // }
    }

    override beatGame() {
        Statistics.instance.recordAdditive(StatNames.BeatEasyMode, 1);
    }

    override forceMinimumStack(): boolean {
        let riseNow: boolean;

        riseNow = this.getHighestOccupiedRow(false) < this.numberOfRowsAtStart - 1;

        if (riseNow == true) {
            this.puzzleController.score.changeTachometerArrow(this.arrowLevel2);
            // this._tachTween.to = this.newTach;
            // this._tachTween.duration = this.newDuration;
            this._interruptRiseUp = true;
        } else {
            if (this._interruptRiseUp == true) {
                // keep it high if youre on last level
                if (this.puzzleController.level + 1 == this.maxLevelToWin) {
                    this._currentMoveUpTurns = this.moveUpTurns - 3;
                    this.puzzleController.score.changeTachometerArrow(this.arrowLevel2);
                    // this._tachTween.to = this.newTach;
                    // this._tachTween.duration = this.newDuration;
                } else {
                    this._setMoveUpTurns();
                }
                this._interruptRiseUp = false;
            }
        }

        return riseNow;
    }

    private _setMoveUpTurns() {
        if (Math.random() <= 0.33) {
            this._currentMoveUpTurns = this.moveUpTurns - 2;
            this.puzzleController.score.changeTachometerArrow(this.arrowLevel3);
        } else {
            if (Math.random() <= 0.5) {
                this._currentMoveUpTurns = this.moveUpTurns - 1;
                this.puzzleController.score.changeTachometerArrow(this.arrowLevel4);
            } else {
                this._currentMoveUpTurns = this.moveUpTurns;
                this.puzzleController.score.changeTachometerArrow(this.arrowLevel5);
            }
        }

        // this._tachTween.to = this.origTach;
        // this._tachTween.duration = this.oldDuration;
    }

    override levelUpSequence() {
        super.levelUpSequence();

        //at last wave, move up = 2!!
        if (this.puzzleController.level + 1 == this.maxLevelToWin) {
            this._currentMoveUpTurns = this.moveUpTurns - 3;
            this.puzzleController.score.changeTachometerArrow(this.arrowLevel2);
            // this._tachTween.to = this.newTach;
            // this._tachTween.duration = this.newDuration;
        } else {
            this._setMoveUpTurns();
        }
    }
}
